var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.tag,
    { tag: "component", attrs: { state: _vm.state } },
    [
      _c("app-load-deposits-modal", { attrs: { state: _vm.state } }),
      _c("app-created-deposits-create-bank", { attrs: { state: _vm.state } }),
      _c("app-car-select-modal", { attrs: { state: _vm.state } }),
      _c("app-carpass-input-modal", {
        attrs: { state: _vm.state.carpassModalData, "show-skip-button": "" },
      }),
      _c("app-processing-message-modal", { attrs: { state: _vm.state } }),
      _c("app-sale-edit-contact-extra-info-edit", {
        attrs: { state: _vm.state },
      }),
      _c("app-sale-edit-sort-rows-modal", { attrs: { state: _vm.state } }),
      _c("app-create-calendar-event-modal", { attrs: { state: _vm.state } }),
      _vm.state
        .addProductsWithNotEnoughInStockBySelectedSupplierSelectGroupModalOpen
        ? _c("app-sale-edit-products-with-not-enough-in-stock-group-select", {
            attrs: { state: _vm.state },
          })
        : _vm._e(),
      _c("app-sale-rows-from-csv-modal", { attrs: { state: _vm.state } }),
      _c("app-sale-edit-row-extra-fields", { attrs: { state: _vm.state } }),
      _c(
        "w-modal",
        {
          attrs: {
            value: _vm.state.productEditRowState.toCreateProduct != null,
          },
        },
        [
          _vm.state.productEditRowState.toCreateProduct
            ? _c("app-edit-product", {
                attrs: {
                  product: _vm.state.productEditRowState.toCreateProduct,
                },
                on: {
                  cancel: function ($event) {
                    return _vm.state.productEditRowState.cancelCreateProduct()
                  },
                  input: function ($event) {
                    return _vm.state.productEditRowState.finishCreateProduct(
                      $event
                    )
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }